import { Injectable } from "@angular/core";
import { ICadastroCartao } from "../models/cadastro-cartao";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";

@Injectable({ providedIn: 'root' })
export class PagarmeService {

    constructor(protected http: HttpClient) { }
    getToken(creditCard: ICadastroCartao){
        return this.http
          .post<any>('https://api.pagar.me/core/v5/tokens?appId=pk_test_bW7MxB9fWOHoepyP', {
            card: {
              number: creditCard.cartao,
              holder_name: creditCard.nomecartao,
              exp_month: Number(creditCard.vencimento.substring(0, 2)),
              exp_year: Number(creditCard.vencimento.substring(2, 4)),
              cvv: creditCard.ccv,
              holder_document: creditCard.documento
            },
            type: 'card'
          }, { observe: 'response' }).pipe(map((res: any) => res));
    }
}
